<ng-container *ngIf="mUseVirtualScrool; else elseTemplate">
    <!-- list avec le virtual scroll (en test) -->
    <!-- TODO : Virtual scroll
        - Ajouter séparation entre differente celule
        - Definir une taille fix pour les element du tableau
        - Toujours afficher le header en haut du tableau
        - Gerer dynamiquement la hauteur du tableau        
    -->
    <cdk-virtual-scroll-viewport [style.height.px]="gridHeight">
        <table #MatTable style="width: 100%" mat-table [dataSource]="HTML_DataSource" class="mat-elevation-z8">
            
            <!-- Gere les valeur dynamiquement -->
            <ng-container *ngFor="let item of HTML_ArrayHeaderRef; let i = index">
                <ng-container matColumnDef="{{item}}">
                    <th mat-header-cell *matHeaderCellDef>{{HTML_DynamicHeader[i]?.Name}}</th>
                    <td mat-cell *matCellDef="let element">{{element[i]}}</td>
                </ng-container>
            </ng-container>
            
            <tr mat-header-row *matHeaderRowDef="HTML_ArrayHeaderRef"></tr>
            <ng-template let-row matRowDef 
                cdkVirtualFor 
                [matRowDefColumns]="HTML_ArrayHeaderRef" 
                [cdkVirtualForOf]="HTML_VirtualDataSoruce">
                <tr mat-row></tr>
            </ng-template>
        </table>
    </cdk-virtual-scroll-viewport>
</ng-container>
<ng-template #elseTemplate>
    <table id="table" mat-table [dataSource]="HTML_DataSource" class="mat-elevation-z8 cmat-add-border">
        <!-- Gere les valeur dynamiquement -->
        <ng-container *ngFor="let item of HTML_ArrayHeaderRef; let i = index">
            <ng-container matColumnDef="{{item}}">
                <th mat-header-cell *matHeaderCellDef>{{HTML_DynamicHeader[i]?.Name}}</th>
                <td mat-cell *matCellDef="let element">{{element[i]}}</td>
            </ng-container>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="HTML_ArrayHeaderRef; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: HTML_ArrayHeaderRef;"></tr>
    </table>
</ng-template>

<mat-paginator [ngStyle]="{'display': mUseVirtualScrool ? 'none' : 'invalidate'}" #TablePaginator [pageSize]="100"></mat-paginator>